import ReportViewSnapshot from './reportViewSnapshot'
export default ReportViewSnapshot
